<template>
  <v-container fluid>
    <div style="display: flex">
      <h2 class="primary--text mb-2">{{ $t('url_tracking') }}</h2>
      <a
        href="https://blog.zwiz.app/redirect-url-tracking/"
        target="blank"
        class="primary--text"
        style="align-self: center; margin-left: 6px; margin-bottom: 4px"
        ><i style="font-size: 18px" class="fas fa-question-circle"></i
      ></a>
    </div>
    <div class="d-flex justify-space-between">
      <div>
        <v-btn
          v-for="app in apps"
          :key="app.value"
          small
          depressed
          :outline="selectedApp !== app.value"
          :color="selectedApp === app.value ? 'primary' : 'grey'"
          class="ma-0 mr-1 mb-1"
          @click="onSelected(app.value)"
        >
          <i v-if="app.icon" :class="app.icon" class="mr-1"></i>
          {{ app.label }}
        </v-btn>
      </div>
      <v-btn
        outline
        color="grey"
        :loading="exporting"
        class="ml-auto"
        style="display: inline-block; max-width: 120px"
        @click.prevent.stop="() => exportFile()"
      >
        <!-- @click="exportOrderSummary('separate')" -->
        <i class="fas fa-file-export mr-1"></i>
        {{ $t('export') }}
      </v-btn>
    </div>
    <date-filter
      v-model="selectedDate"
      class="my-3"
      :default-filter="'today'"
      :items-hide="['this_year', 'last_365_day']"
      @onSelected="handleDateSelected"
    />

    <v-data-table
      class="my-3 elevation-1 scgallrenttable"
      :loading="loading"
      :headers="headers"
      :items="items"
      :rows-per-page-items="[10, 25, 50]"
      :pagination.sync="pagination"
    >
      <template #items="{ item }">
        <tr>
          <td>{{ item.action }}</td>
          <td>{{ item.value }}</td>
          <td class="text-xs-right">{{ item.number_of_users | numberFormat }}</td>
          <td class="text-xs-right">{{ item.number_of_clicks | numberFormat }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
import DateFilter from '../../analytics/DateFilter'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      loading: false,
      selectedApp: 'all',
      selectedDate: {
        start: dayjs().startOf('dates').format('YYYY-MM-DD HH:mm'),
        end: dayjs().endOf('dates').format('YYYY-MM-DD HH:mm')
      },
      headers: [
        {
          text: this.$t('Topics'),
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('Value'),
          value: 'sum_value',
          sortable: false
        },
        {
          text: this.$t('Total People'),
          value: 'total_distinct_userid',
          align: 'right',
          sortable: false
        },
        {
          text: this.$t('Total Count'),
          value: 'count',
          align: 'right',
          sortable: false
        }
      ],
      items: [],
      total: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      exporting: false
    }
  },
  watch: {
    pagination() {
      this.fetch()
    }
  },
  methods: {
    getData(data) {
      const { start, end } = this.selectedDate
      const { page, rowsPerPage } = this.pagination

      return this.post(`api/cms/v1/analytics/${this.selectedBot.pageid}/redirect-event-log`, {
        app: this.selectedApp === 'all' ? undefined : this.selectedApp,
        start_date: dayjs(start).format('YYYY-MM-DD'),
        end_date: dayjs(end).format('YYYY-MM-DD'),
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...data
      })
    },
    async fetch() {
      this.loading = true

      try {
        const response = await this.getData()
        if (response.status !== 200) return
        const { data, total } = response.data
        this.items = data
        this.total = total
      } catch (err) {
        console.log('err: ', err)
      } finally {
        this.loading = false
      }
    },
    onSelected(app) {
      this.selectedApp = app
      this.pagination = { ...this.pagination, page: 1 }
    },
    async exportFile() {
      try {
        this.exporting = true

        const response = await this.getData({
          limit: 10000,
          offset: 0
        })
        if (response.status !== 200) return
        const { data: items } = response.data
        const rows = items.map((item) => {
          return {
            [this.$t('Topics')]: item.action,
            [this.$t('Value')]: item.value,
            [this.$t('Total People')]: item.number_of_users,
            [this.$t('Total Count')]: item.number_of_clicks
          }
        })
        const fileName = 'url_tracking'
        const dataWS = XLSX.utils.json_to_sheet(rows)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, fileName + '.xlsx')
      } catch (error) {
        console.error(error)
      } finally {
        this.exporting = false
      }
    },
    handleDateSelected(date) {
      this.selectedDate = date
      this.pagination = { ...this.pagination, page: 1 }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    apps() {
      const packages = this.selectedBot.packages
      const apps = [
        {
          label: this.$t('all'),
          value: 'all'
        }
      ]

      if (packages.includes('facebook')) {
        apps.push({
          label: this.$t('Facebook'),
          value: 'facebook',
          icon: 'fab fa-facebook-square'
        })
      }
      if (packages.includes('line')) {
        apps.push({
          label: this.$t('Line'),
          value: 'line',
          icon: 'fab fa-line'
        })
      }
      if (packages.includes('instagram')) {
        apps.push({
          label: this.$t('Instagram'),
          value: 'instagram',
          icon: 'fab fa-instagram'
        })
      }

      apps.push({
        label: this.$t('Webchat'),
        value: 'webchat',
        icon: 'fa fa-globe'
      })

      return apps
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/UrlTracking/index.vue